import { Pipe, PipeTransform } from '@angular/core';
import { padStart } from 'lodash';

@Pipe({
    name: 'hourRange',
    standalone: false
})
export class HourRangePipe implements PipeTransform {
  transform(n: number): string {
    return padStart(n.toString(), 2, '0') + ':00 - ' + padStart(n.toString(), 2, '0') + ':59';
  }
}
